import React, { useState, useEffect, useContext } from 'react';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import './declareSourceRemark.scss';
import CommonTextField from '../../../Components/TextField/textField';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import {
  getKpiSourceAndRemarksDetails,
  updateKpiSourceAndRemarksDetails,
} from '../../../Api/request/performance';
import UseAxios from '../../../Api/http/http';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import {
  DECLARE_SOURCE_REMARK,
  AUTHENTICATION_FAILED,
} from '../../../Constants/strings';

const DecalreSourceRemark = () => {
  const [formData, setFormData] = useState({ kpiDetails: [] });
  const [autoFocus, setAutoFocus] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [errors, setErrors] = useState({});
  const { snackbarOpen } = useSnackbar();
  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_REMARKS] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  useEffect(() => {
    fetchKpiDetailsList();
  }, []);

  const fetchKpiDetailsList = async () => {
    try {
      const response = await UseAxios(getKpiSourceAndRemarksDetails());
      setFormData(response.data);
      setIsDirty(false);
    } catch (err) {
      setFormData({ kpiDetails: [] });
      setIsDirty(false);
      console.error('Error fetching KPI details:', err);
    }
  };

  const handleChange = (kpiIndex, optionIndex, field, value) => {
    const updatedData = { ...formData };
    updatedData.kpiDetails[kpiIndex].kpiOptions[optionIndex][field] = value;
    const newErrors = { ...errors };

    const isInvalid = (val) => (val.length >= 1 && val.length < 3) || val.length > 255;

    const setFieldError = () => {
      if (!newErrors[kpiIndex]) newErrors[kpiIndex] = {};
      if (!newErrors[kpiIndex][optionIndex]) newErrors[kpiIndex][optionIndex] = {};
      newErrors[kpiIndex][optionIndex][field] = 'Must be 3 to 255 characters';
      setErrors(newErrors);
      setIsDirty(false);
    };

    const removeFieldError = () => {
      if (newErrors[kpiIndex]?.[optionIndex]?.[field]) {
        delete newErrors[kpiIndex][optionIndex][field];
        if (Object.keys(newErrors[kpiIndex][optionIndex]).length === 0) {
          delete newErrors[kpiIndex][optionIndex];
        }
        if (Object.keys(newErrors[kpiIndex]).length === 0) {
          delete newErrors[kpiIndex];
        }
      }
      setErrors(newErrors);
      setIsDirty(Object.keys(newErrors).length === 0);
    };

    if (isInvalid(value)) {
      setFieldError();
    } else {
      removeFieldError();
    }
    setFormData(updatedData);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleResponse = (responseData) => {
    switch (responseData.data.statusCode || responseData.status) {
    case 200:
      fetchKpiDetailsList();
      snackbarOpen(DECLARE_SOURCE_REMARK.SUCESS_MESSAGE, 'success');
      setExpanded(false);
      setIsDirty(false);
      break;
    case 400:
      snackbarOpen(responseData.data.externalMessage, 'warning');
      break;
    case 401:
      snackbarOpen(AUTHENTICATION_FAILED, 'warning');
      break;
    case 500:
      snackbarOpen(DECLARE_SOURCE_REMARK.UNABLE_TO_UPDATE, 'warning');
      break;
    default:
      snackbarOpen(DECLARE_SOURCE_REMARK.UNABLE_TO_UPDATE, 'warning');
      break;
    }
  };

  const handleSave = async () => {
    const payload = {
      kpiDetails: formData.kpiDetails.flatMap((kpiCat) =>
        kpiCat.kpiOptions.map((option) => ({
          kpiId: option.kpiId,
          sourceId: option.sourceId,
          sourceName: option.sourceName || '',
          remarks: option.remark || '',
        })),
      ),
      lastUpdatedBy: userProfile?.user_name,
    };
    try {
      const response = await UseAxios(
        updateKpiSourceAndRemarksDetails(payload),
      );
      handleResponse(response);
      setAutoFocus(false);
    } catch (err) {
      snackbarOpen(DECLARE_SOURCE_REMARK.UNABLE_TO_UPDATE, 'warning');
      console.error('Error:', err);
    }
  };

  return (
    <div>
      <h2 className="declare-source-title">{DECLARE_SOURCE_REMARK.TITLE}</h2>
      <div className='declare-source-wrapper'>
        {formData.kpiDetails.map((kpi, kpiIndex) => (
          <Accordion
            key={kpi.kpiCategoryId}
            expanded={expanded === kpi.kpiCategoryId}
            onChange={handleAccordionChange(kpi.kpiCategoryId)}
            sx={{
              background: '#F1F5F8',
              width: '100%',
              marginBottom: 2,
              paddingY: 1,
              borderRadius: '4px',
              boxShadow: 'none',
              border: 'none',
              '&::before': {
                visibility: 'hidden',
              },
            }}
          >
            <AccordionSummary expandIcon={<GridExpandMoreIcon />}>
              <div className='source-remarks-header-accordion'>
                {kpi.kpiCategory}
              </div>
            </AccordionSummary>
            <AccordionDetails>
              {kpi.kpiOptions.map((option, optionIndex) => (
                <div key={option.kpiId} className='text-field-row '>
                  <div style={{ flex: 0.6 }} className='source-remarks-header'>
                    {option.kpiName}
                  </div>
                  <div className='source-div'>
                    <div className='source-remarks-font'>
                      {DECLARE_SOURCE_REMARK.DECLARE_SOURCE}
                    </div>
                    <div>
                      <CommonTextField
                        textCss='full-width-declare-source-remark'
                        textFieldClassName='text-field-source-remark'
                        value={option.sourceName}
                        autoFocus={true}
                        onChange={(event) =>
                          handleChange(
                            kpiIndex,
                            optionIndex,
                            'sourceName',
                            event.target.value,
                          )
                        }
                      />
                      {errors[kpiIndex]?.[optionIndex]?.['sourceName'] && (
                        <div className="declare-source-remark-error">
                          <small>{errors[kpiIndex][optionIndex]['sourceName']}</small>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='remarks-div'>
                    <div className='source-remarks-font'>
                      {DECLARE_SOURCE_REMARK.DECLARE_REMARK}
                    </div>
                    <div>
                      <CommonTextField
                        textCss='full-width-declare-source-remark'
                        textFieldClassName='text-field-source-remark'
                        value={option.remark}
                        autoFocus={autoFocus}
                        onChange={(event) =>
                          handleChange(
                            kpiIndex,
                            optionIndex,
                            'remark',
                            event.target.value,
                          )
                        }
                      />
                      {errors[kpiIndex]?.[optionIndex]?.['remark'] && (
                        <div className="declare-source-remark-error">
                          <small>{errors[kpiIndex][optionIndex]['remark']}</small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>

      <div className='sticky-footer-source-remark '>
        <button
          className={!isDirty ? 'disabled-button-add-source-remark' : 'button-add-source-remark'}
          onClick={handleSave}
          disabled={!hasAccess('update') || !isDirty}
          style={{
            cursor: !hasAccess('update') || !isDirty ? 'not-allowed' : 'pointer',
          }}
        >
          {DECLARE_SOURCE_REMARK.SAVE}
        </button>
      </div>
    </div>
  );
};

export default DecalreSourceRemark;
